import React, {useEffect, useRef, useState} from "react";
import ReactCardCarousel from "react-card-carousel";

export const Cover = () => {
    const containerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [clicked, setClicked] = useState(false);

    const enviarMensaje = (tipo, data) => {
        const manager = window.VTWidgetBridge.Bridge.raiseEvent(tipo, data);
        console.log(tipo);
        console.log(data);
        console.log(manager);
    };

    useEffect(() => {
        const updateSize = () => {
            if (containerRef.current) {
                const { clientWidth, clientHeight } = containerRef.current;
                setDimensions({ width: clientWidth, height: clientHeight });
            }
        };

        // Usamos ResizeObserver para detectar cambios en el tamaño del contenedor
        const resizeObserver = new ResizeObserver(updateSize);
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        // Cleanup al desmontar
        return () => resizeObserver.disconnect();
    }, []);


    var cards = [{"code":"DEFAULT","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222103153.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"DEFAULT_QR","btnPrimaryText":"Try our Innovation Laboratory","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"SCAN_QR","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110605.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"SCAN_QR","btnPrimaryText":"Try your own app!","btnSecondaryExist":true,"btnSecondarycolor":"#070DFA","btnSecondaryHash":"LAST_QR","btnSecondaryText":"Re-open the last experience"},{"code":"BANORTE","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222102905.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250222100840.png","text":"","textSize":20,"textColor":"#ED0029","btnPrimaryExist":true,"btnPrimarycolor":"#ED0029","btnPrimaryHash":"D39409D148AC99A83AF11258E9AB7FC0DB8FC1BE","btnPrimaryText":"Try our Retail Banking Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"ZERO","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250503051841.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250503052145.png","text":"","textSize":20,"textColor":"#49EBDC","btnPrimaryExist":true,"btnPrimarycolor":"#49EBDC","btnPrimaryHash":"D0E446BE40A0C2544B6E882A684722569B084F0E","btnPrimaryText":"Try our Wallet Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"CDNI","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222102927.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250222100903.png","text":"","textSize":20,"textColor":"#FFF","btnPrimaryExist":true,"btnPrimarycolor":"#279D2E","btnPrimaryHash":"B5030390E178A6006B2F19E9C193CB699813FBE7","btnPrimaryText":"Try our Retail Wallet Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"MCITY","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222100448.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250222103700.png","text":"","textSize":20,"textColor":"#FFFFFF","btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"7B9C0F7844D83294A0975ABFF2187391D2B422F0","btnPrimaryText":"Try our FAN Enrollment Experience","btnSecondaryExist":true,"btnSecondarycolor":"#070DFA","btnSecondaryHash":"7B9C0F7844D83294A0975ABFF2187391D2B422F0_SCANNER","btnSecondaryText":"Try our Ticket Validator Experience"},{"code":"COLUMBIA","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250413184022.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250321142655.png","text":"","textSize":20,"textColor":"#FFFFFF","btnPrimaryExist":true,"btnPrimarycolor":"#052d75","btnPrimaryHash":"194732863F3EEF35BE3F0851AC804A6AEFD7FFFC","btnPrimaryText":"Try our Wallet experience","btnSecondaryExist":false,"btnSecondarycolor":"#052d75","btnSecondaryHash":"","btnSecondaryText":""},{"code":"DEFAULT_MEXICO","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250504080917.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"E0D92DA92358A79A1C6C9614C43B124113BF409M","btnPrimaryText":"Try our Mexico Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"DEFAULT_ARGENTINA","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250504081030.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"E0D92DA92358A79A1C6C9614C43B124113BF409A","btnPrimaryText":"Try our Argentina Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"DEFAULT_BRASIL","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250504081105.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"E0D92DA92358A79A1C6C9614C43B124113BF409B","btnPrimaryText":"Try our Brazil Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"DEFAULT_COLOMBIA","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250504081133.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"E0D92DA92358A79A1C6C9614C43B124113BF409C","btnPrimaryText":"Try our Brazil Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"DEFAULT_UNITED_KINGDOM","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250504081221.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"E0D92DA92358A79A1C6C9614C43B124113BF409K","btnPrimaryText":"Try our UK Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"DEFAULT_EUROPE","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250504081249.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"E0D92DA92358A79A1C6C9614C43B124113BF409K","btnPrimaryText":"Try our Europe Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""},{"code":"DEFAULT_USA","image":"https://vxapp.wfsystems.com.ar/storage/logos/20250504081341.png","logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png","text":"","textSize":20,"btnPrimaryExist":true,"btnPrimarycolor":"#070DFA","btnPrimaryHash":"E0D92DA92358A79A1C6C9614C43B124113BF409U","btnPrimaryText":"Try our USA Experience","btnSecondaryExist":false,"btnSecondarycolor":"","btnSecondaryHash":""}];



    /*

     {
            "code":"COLUMBIA",
            "image":"https://vxapp.wfsystems.com.ar/storage/logos/20250413184022.png",
            "logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250321142655.png",
            "text":"",
            "textSize":20,
            "textColor":"#FFFFFF",
            "btnPrimaryExist":true,
            "btnPrimarycolor":"#052d75",
            "btnPrimaryHash":"194732863F3EEF35BE3F0851AC804A6AEFD7FFFC",
            "btnPrimaryText":"Try our Wallet experience",
            "btnSecondaryExist":false,
            "btnSecondarycolor":"#052d75",
            "btnSecondaryHash":"",
            "btnSecondaryText":"",
        },
     */

    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100vw',height:'100vh'}}>
            <div  ref={containerRef}  style={styles.containerStyle}>

                <ReactCardCarousel spread="narrow" autoplay={false} autoplay_speed={2000}>
                    {cards.map((card, index) => {
                        return (
                            <div style={{
                                ...getCardStyles(dimensions),
                                position: 'relative',

                            }}>
                                <img
                                    src={card.image}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        objectPosition: "center",
                                        top: 0,
                                        left: 0,
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 20,
                                        borderBottomLeftRadius: 20,
                                        borderBottomRightRadius: 20,
                                        zIndex: 0
                                    }}
                                />

                                {/* Contenedor del logo y el texto */}
                                <div style={{
                                    height: '50%',
                                    paddingTop: '10%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, ${'#FFFFFF'} 60%)`,
                                    borderTopLeftRadius: 20,
                                    borderTopRightRadius: 20,
                                    borderBottomLeftRadius: 20,
                                    borderBottomRightRadius: 20,
                                    paddingBottom:5,
                                    zIndex: 1 // 🔥 Está por encima de la imagen
                                }}>

                                    <span style={getCardSpanStyles(dimensions, card)}>{card.text}</span>

                                    {card.logo != "" &&
                                        <img src={card.logo} style={getCardLogoStyles(dimensions)}/>
                                    }

                                    {card.btnPrimaryExist &&
                                        <button
                                            id={"btnTryMe"}
                                            className={'btn-tryme'}
                                            style={getCardButtonPrimaryStyles(dimensions, card)}
                                            onClick={() =>{
                                                setClicked(!clicked);
                                                enviarMensaje("vtOnClick", {vtHash: card.btnPrimaryHash })}}>
                                            {card.btnPrimaryText}
                                        </button>}

                                    {card.btnSecondaryExist &&
                                        <button
                                            id={"btnTryMe"}
                                            className={'btn-tryme'}
                                            style={getCardButtonSecondaryStyles(dimensions, card)}
                                            onClick={() =>{
                                                setClicked(!clicked);
                                                enviarMensaje("vtOnClick", {vtHash: card.btnSecondaryHash })}}>
                                            {card.btnSecondaryText}
                                        </button>}
                                    {!card.btnSecondaryExist &&
                                        <div style={{height:40, width:'100%'}}></div>}
                                </div>
                            </div>

                        )
                    })}
                </ReactCardCarousel>
            </div>
        </div>
    );
};


// Función para calcular el estilo dinámico de las cards
const getCardStyles = (dimensions) => ({
    height: dimensions.height * 0.95 || "95%",
    width: dimensions.width * 0.7 || "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    backgroundColor: '#FFF',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
});

const getCardSpanStyles = (dimensions,card) => ({
    fontSize: card.textSize || 20,
    width: '80%',
    textAlign:'center',
    fontFamily: "Open Sans",
    textTransform: "uppercase",
    fontWeight: "bold",
    color: card.textColor || "#FFF",
    height:60,
});

const getCardLogoStyles = (dimensions) => ({
    //height: dimensions.width * 0.25,
    width: dimensions.width * 0.25,
    objectFit: 'contain',
    margin:10,
});


const getCardButtonPrimaryStyles = (dimensions, card) => ({
    height: 40,
    width: '80%',
    backgroundColor: card.colorButton,
    color: '#FFF',
    borderStyle: 'solid',
    borderColor: card.colorButton,
    borderWidth: 1,
    borderRadius: 7,
    marginTop: 2,
    marginBottom: 2,
    fontSize: 12,
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
});
const getCardButtonSecondaryStyles = (dimensions, card) => ({
    height: 40,
    width: '80%',
    backgroundColor: '#FFF',
    color: card.colorButton,
    borderStyle: 'solid',
    borderColor: card.colorButton,
    borderWidth: 1,
    borderRadius: 7,
    marginTop: 2,
    marginBottom: 2,
    fontFamily: 'Open Sans',
});

const getCardButtonLegendStyles = (dimensions, card) => ({
    height: 40,
    width: '80%',
    backgroundColor: 'transparent',
    color: card.colorButton,
    textDecoration: 'underline',
    fontWeight: 'bold',
    borderStyle: 'none',
    borderRadius: 7,
    marginTop: 2,
    marginBottom: 2,
    fontFamily: 'Open Sans',
});



const styles = {
    containerStyle: {
        width: "100%",
        height: "100%",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundColor: '#0A172C',
        backgroundSize: "cover",   // Para que cubra todo el contenedor
        backgroundPosition: "center", // Centrar la imagen
        backgroundRepeat: "no-repeat", // Evitar repeticiones
    },
};

export default Cover;
